// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject12":"MecanoCNC-module--seeLiveProject12--3-WmW","sourceCodeProject12":"MecanoCNC-module--sourceCodeProject12--2ONse"};